import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${({ theme }) => theme.spacing.S8};
`;

const Subtitle = styled.p`
  ${({ theme }) => theme.fontSize.B12};
  text-align: center;
`;

const Image = styled.img`
  max-height: 20px;
  max-width: 80px;
`;

export { Container, Subtitle, Image };
